import React from 'react';

import { ConfirmDialog } from '@gogame/components';
import { LegacyTextList } from '@gogame/components';
import { useMutation } from '@gogame/query';
import { useScreenModalV2 } from '@gogame/screens';

import { batchStartIntegration } from 'scenes/Integrations/sources/integrations';
import { getConfigurationTypeId } from 'scenes/Integrations/utils';

import { start } from '../queryKeyFactory';
import { errorMessageGetter } from './errorMessageGetter';

export const useBatchStart = () => {
  const showModal = useScreenModalV2(ConfirmDialog);

  const startMutation = useMutation(start(), batchStartIntegration, {
    refresh: true,
    successMessage: (_data, variables) => {
      return `${variables.ids.length} Integration(s) activated`;
    },
    errorMessage: errorMessageGetter,
  });

  const handleStart = async (rows) => {
    const data = rows.map(({ id }) => ({ id, name: `#${id}` }));
    const ids = rows.map((data) => ({
      id: data.id,
      configurationTypeId: getConfigurationTypeId(data),
    }));
    await showModal({
      title: `Activate Integration(s)?`,
      confirmActionLabel: 'Activate',
      children: (
        <LegacyTextList
          data={data}
          limit={5}
          unitsName={'Integrations'}
          withContentTooltip={false}
        />
      ),
    });
    await startMutation.mutateAsync({ ids });
  };

  return [handleStart, startMutation];
};
